import React from 'react'
import { MuiGrid } from '../../../ui/MaterialUIComponents';
import IndividualTimeTableGrid from './IndividualTimeTableGrid';
import CalendarGrid from './CalendarGrid'
export default function IndividualTimeTableForForTeacher(props) {
    let header = props.header
    let roomsTimeTable = props.roomsTimeTable;
    return (
        <MuiGrid container>
            {roomsTimeTable != undefined && roomsTimeTable.map((room, index2) => (
                <CalendarGrid {...props} title={room.name} index={index2}
                    noOfTTShowIndex={props.noOfRoomsTimeTableToShowIndex}
                >
                    <IndividualTimeTableGrid
                     {...props} 
                     header={header}
                      classItem={room}
                       cardIndex={index2}
                        noOfTTShowIndex={props.noOfRoomsTimeTableToShowIndex}
                       />
                </CalendarGrid>
            ))}
        </MuiGrid>
    )
}